var render = function render(){var _vm=this,_c=_vm._self._c;return _c('HelpComponent',[_c('b-row',{staticClass:"mb-3"},[_c('b-col',[_vm._v(" Vos bons de livraison appro sont téléchargeables dans cet écran le lendemain de leur facturation par votre coopérative. ")])],1),_c('b-row',[_c('b-col',[_vm._v(" Un même bon de livraison peut contenir plusieurs lignes de ce tableau. ")])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }